import { render, staticRenderFns } from "./MagazineList.vue?vue&type=template&id=0de32305&scoped=true"
import script from "./MagazineList.vue?vue&type=script&lang=js"
export * from "./MagazineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de32305",
  null
  
)

export default component.exports